__turbopack_context__.v({
  "ctaWrapper": "TextEyebrow-module-scss-module__mpKnhG__ctaWrapper",
  "display": "TextEyebrow-module-scss-module__mpKnhG__display",
  "displayLarge": "TextEyebrow-module-scss-module__mpKnhG__displayLarge",
  "displaySmall": "TextEyebrow-module-scss-module__mpKnhG__displaySmall",
  "displaySmallToLarge1": "TextEyebrow-module-scss-module__mpKnhG__displaySmallToLarge1",
  "displayXSmall": "TextEyebrow-module-scss-module__mpKnhG__displayXSmall",
  "innerDisplayText": "TextEyebrow-module-scss-module__mpKnhG__innerDisplayText",
  "innerHeadline": "TextEyebrow-module-scss-module__mpKnhG__innerHeadline",
  "innerHeadlineDisplay": "TextEyebrow-module-scss-module__mpKnhG__innerHeadlineDisplay",
  "innerText": "TextEyebrow-module-scss-module__mpKnhG__innerText",
  "innerTextWrapper": "TextEyebrow-module-scss-module__mpKnhG__innerTextWrapper",
  "masthead": "TextEyebrow-module-scss-module__mpKnhG__masthead",
  "paragraph": "TextEyebrow-module-scss-module__mpKnhG__paragraph",
  "richTextLink": "TextEyebrow-module-scss-module__mpKnhG__richTextLink",
  "root": "TextEyebrow-module-scss-module__mpKnhG__root",
  "textAlignLeft": "TextEyebrow-module-scss-module__mpKnhG__textAlignLeft",
  "theme--makers-reserve": "TextEyebrow-module-scss-module__mpKnhG__theme--makers-reserve",
  "ultrabold": "TextEyebrow-module-scss-module__mpKnhG__ultrabold",
});
